import { Text } from '@hg/stylizator/typography'
import * as React from 'react'
import styled from 'styled-components'

type TProps = React.ComponentProps<typeof Background>

const Tag: React.FC<React.PropsWithChildren<TProps>> = ({ children, ...props }) => (
  <Background {...props}>
    <Text type="compact_subtitle" color="currentColor">
      <span>{children}</span>
    </Text>
  </Background>
)

export default Tag

const Background = styled.a`
  display: inline-block;
  cursor: pointer;
  padding: 4px 8px;
  background: ${(props) => props.theme.color.blue[20]};
  border: none;
  border-radius: 4px;
  color: ${(props) => props.theme.color.blue[60]};

  &:hover {
    background: ${(props) => props.theme.color.blue[30]};
  }
`
